import { Fixtuur } from '@fixtuur/backpack';
import { createSelector } from '@reduxjs/toolkit';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/lib/function';
import { RootState } from '../../store';

export const selections = (state: RootState) => state.selections;

export const productSelectionsByPart = createSelector(
    selections,
    state => state.productSelectionsByPart,
);

export const buildPropertySelections = createSelector(
    selections,
    state => state.buildPropertySelections,
);

export const selectedProductIds = createSelector(productSelectionsByPart, productSelections => {
    if (productSelections) {
        return Object.values(productSelections).map(Fixtuur.Configuration.Option.value);
    } else {
        return null;
    }
});

/**
 * Turns productSelectionsPerPart into a domain Selections object by extracting out the selections
 * and ignoring the parts.
 *
 * Returns null if state is still loading.
 */
export const productSelections = createSelector(
    productSelectionsByPart,
    productSelectionsByPart => {
        if (!productSelectionsByPart) {
            return null;
        }
        return Fixtuur.Configuration.Selections.fromProductSelectionsByPart(
            productSelectionsByPart,
        );
    },
);

/**
 * Gets the grouping code selections for the root product.
 *
 * This will be null if state is still loading.
 */
export const groupingCodeSelections = createSelector(
    selections,
    state => state.groupingCodeSelections,
);

export const attachmentProposals = createSelector(selections, state =>
    pipe(
        O.Do,
        O.bind('selectedOptionKey', () =>
            O.fromNullable(state.attachmentProposals?.selectedOptionKey),
        ),
        O.bind('selectedValue', () => O.fromNullable(state.attachmentProposals?.selectedValue)),
        O.map(({ selectedOptionKey, selectedValue }) => ({ [selectedOptionKey]: selectedValue })),
        O.toNullable,
    ),
);

export const attachmentSelections = createSelector(selections, state => state.attachmentSelections);
